import { useGetBuyerSpendingLimit } from '@api/lendingAPI/lapiHooks';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';

import payLaterIllustrationSvg from './payLaterIllustration.svg';
import { RefreshReminder } from './RefreshReminder';
import styles from './SpendingLimitView.module.css';
import { RefreshExpiredLimits } from '../spendingLimitCard/components/RefreshExpiredLimits';

function SpendingLimitView({
    setIsSpendingLimitDrawerOpen,
    loadingRefreshSpendingLimit,
    refreshSpendingLimit
}: {
    setIsSpendingLimitDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
    loadingRefreshSpendingLimit: boolean;
    refreshSpendingLimit: () => void;
}) {
    const { buyerSpendingLimit } = useGetBuyerSpendingLimit();

    // TODO: Consider useGetSpendingLimits to get active_spending_limit to prevent duplication
    const isLimitValid = Boolean(
        buyerSpendingLimit?.active_spending_limit?.is_valid
    );
    const creditLimit =
        buyerSpendingLimit?.active_spending_limit?.available_amount;

    return (
        <div className={styles.viewContainer}>
            <div className={styles.view}>
                <div data-testid="spending-limit-heading">
                    {!isLimitValid && (
                        <h2 className="m-0 flex items-center gap-s pb-s text-l font-med">
                            Click{' '}
                            <RefreshExpiredLimits
                                className="text-l"
                                loading={loadingRefreshSpendingLimit}
                                setIsSpendingLimitDrawerOpen={
                                    setIsSpendingLimitDrawerOpen
                                }
                                refreshSpendingLimit={refreshSpendingLimit}
                            />{' '}
                            to refresh your spending limit
                        </h2>
                    )}
                    <h2 className="m-0 pb-l text-l font-med">
                        Here's how to use your{' '}
                        {isLimitValid ? (
                            <FormattedCurrency value={creditLimit!} />
                        ) : null}{' '}
                        spending limit:
                    </h2>
                </div>
                <div className={styles.gridContainer}>
                    <div className={styles.circle}>1</div>
                    <div className={styles.stepItem}>
                        Choose to pay with 'Pay Later' from iwocaPay - with any
                        iwocaPay supplier at their checkout or via a link on
                        their invoice
                    </div>
                    <div className={styles.circle}>2</div>
                    <div className={styles.stepItem}>
                        Sign into your iwocaPay account - your spending limit
                        will be automatically applied
                        <div className={styles.illustrationImg}>
                            <img
                                src={payLaterIllustrationSvg}
                                alt="Pay Later Illustration"
                            />
                        </div>
                    </div>
                    <div className={styles.circle}>3</div>
                    <div className={styles.stepItem}>
                        Finish checking out as normal - your supplier gets paid
                        instantly, you spread the cost over manageable monthly
                        payments
                    </div>
                </div>
                <RefreshReminder />
            </div>
        </div>
    );
}

// eslint-disable-next-line import/no-default-export
export default SpendingLimitView;
